import React, { Component } from 'react'
import FixedView from '../FixedView'
import StagesManager from '../StagesManager'
import IntractionActionsList from '../IntractionActionsList'
import importedIcons from '../inputs/icons'

export default class SettingsMenu extends Component {

    state={
        showFixed:false
    }

    componentDidMount(){
        setTimeout(() => {
            this.setState({showFixed:true})
        }, 50);
    }

    changeWindow = (list) => {
        this.props.changeWindow(list)

        this.fixedView.hideView()

    }


    changeFrame = (item) => {
        // this.props.changePage(item)
        this.props.functionsHandler(null, 'changePage', ['settings', item])
        this.fixedView.hideView()
    }


    render() {

        let colors = this.props.colors

        return (
            <>
                <button className='mld-2 flexcc dark-blur-hover p-1 br-5' ref={el => this.setting = el} onClick={() => { this.fixedView.showView() }}>
                    <img width={24} className={(colors?.iconInvert ? 'invert' : '')} src='/assets/icons/applets/database/setting-white.svg' />
                </button>
                {this.state.showFixed && (
                    <FixedView width={this.props.width} zIndex={10} ref={el => this.fixedView = el} nodeRef={this.setting} xOffset={219} bottomOffset={0} topOffset={0} maxWidth={260} >
                        <div className='bg-white br-10 p-1 shadow-3 sc-gray2'>
                            <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                                <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'ّfile'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                    <div className='mb-2'>
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Applet settings", shortcut: 'Ctrl+O', icon: importedIcons.setting }} onClick={() => this.changeFrame('config')} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Permissions", icon: importedIcons.permisions }} onClick={() => this.changeFrame('permissions')} />
                                        {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Applet Permissions", icon: "/assets/icons/note/file/copy.svg" }} onClick={() => this.changeFrame('appletpermissions')} /> */}
                                    </div>
                                    <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Workflows & automations", icon: importedIcons.automation }} onClick={() => this.changeFrame('automations')} />
                                        {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Stages",  icon: "/assets/icons/note/file/email.svg" }} onClick={() => this.changeFrame('stages')} /> */}
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Actions", icon: importedIcons.action }} onClick={() => this.changeFrame('actions')} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}Variables", icon: importedIcons.variables }} onClick={() => this.changeFrame('variables')} />

                                        {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Stages", sub: true, icon: "/assets/icons/note/file/download.svg" }} onClick={() => this.props.functionsHandler(null, 'changeWindow', ["{{username}}", "{{appletSlug}}",'admin', 'settings','applet'])}/> */}
                                    </div>
                                    <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Collections", icon: importedIcons.addCollection }} onClick={() => this.changeFrame('collections')} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Pages", icon: importedIcons.pages }} onClick={() => this.changeFrame('pages')} />

                                    </div>
                                    <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.User Perspective", icon: importedIcons.userPerspective }} onClick={() => this.changeFrame('pages')} />
                                    </div>

                                    <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList onClick={() => this.changeFrame('')} language={this.props.language} data={{ title: "{{lang}}Open Settings", icon: importedIcons.setting }} />
                                    </div>

                                    <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}setting.Help", icon: importedIcons.exclamation }} />
                                    </div>
                                </div>
                            </StagesManager>
                        </div>
                    </FixedView>
                )}
            </>
        )
    }
}
